import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import { useAppDispatch } from 'common/hooks/redux'
import { SidebarRightMenu } from 'common/icons'
import { hideRightPanel } from 'features/unifiedFlow/store/unifiedFlowSlice'

const ExpandedIcons = () => {
  const dispatch = useAppDispatch()
  const commonClassName = 'cursor-pointer hover:text-gold-700'
  return (
    <ButtonWithTooltip
      data-testid="language-context-sidebar-button"
      variant="icon"
      tooltip
      tooltipText="Language context"
      placement="left"
      onClick={() => dispatch(hideRightPanel())}
      prefixIcon={
        <SidebarRightMenu
          size={6}
          isDefaultColor={false}
          className={commonClassName}
        />
      }
    />
  )
}

export default ExpandedIcons
